import React from "react"
import { Card, Space, Typography, Tag, Divider, Button } from "antd"
import { DollarOutlined } from "@ant-design/icons"
import { textNumberFormater, formatDateTime, getPaymentMethodLabel } from "../../utils"
import { IMovementRS } from "../../models/storageModel"

const { Text } = Typography

export interface MovementDetailDebtCardProps {
  movement: Partial<IMovementRS>
  isPreparatory: boolean
  total: number
  pendingBalance: number
  isPaidInFull: boolean
  paymentOptions?: any[]
  onOpenPaymentModal: () => void
}

const MovementDetailDebtCard: React.FC<MovementDetailDebtCardProps> = ({
  movement,
  isPreparatory,
  total,
  pendingBalance,
  isPaidInFull,
  paymentOptions,
  onOpenPaymentModal,
}) => {
  const shouldShow = !isPreparatory && (
    movement.execution_mode === "DEFERRED" ||
    movement.payment_term === "CREDIT" ||
    (movement.balance_due_amount !== undefined && movement.balance_due_amount > 0) ||
    (movement.payments && movement.payments.length > 0)
  )

  if (!shouldShow) return null

  return (
    <Card 
      title={
        <Space>
          <DollarOutlined style={{ color: "#52c41a" }} />
          <span>Estado de Cartera / Saldo</span>
        </Space>
      } 
      className="card-shadow" 
      style={{ marginBottom: 16, borderTop: '3px solid #52c41a' }}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {movement.payment_term && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text type="secondary">Término de Venta:</Text>
            <Tag color={movement.payment_term === "CREDIT" ? "volcano" : "blue"}>
              {movement.payment_term === "CREDIT" ? `Crédito (${movement.credit_days || 30} días)` : "Contado"}
            </Tag>
          </div>
        )}
        {movement.credit_due_date && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">Vence el:</Text>
            <Text strong>{movement.credit_due_date}</Text>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text type="secondary">Total Facturado:</Text>
          <Text strong>{textNumberFormater(total)}</Text>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text type="secondary">Total Pagado / Abonado:</Text>
          <Text strong style={{ color: '#52c41a' }}>{textNumberFormater(movement.total_paid_amount || 0)}</Text>
        </div>
        <Divider style={{ margin: '6px 0' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Text strong>Saldo Pendiente:</Text>
          <Text strong style={{ fontSize: 16, color: pendingBalance > 0 ? '#f5222d' : '#52c41a' }}>
            {textNumberFormater(pendingBalance)}
          </Text>
        </div>
        {!isPaidInFull && (
          <Button
            type="primary"
            block
            icon={<DollarOutlined />}
            style={{ marginTop: 8, backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            onClick={onOpenPaymentModal}
          >
            Registrar Abono
          </Button>
        )}

        {movement.payments && movement.payments.length > 0 && (
          <>
            <Divider style={{ margin: '12px 0 6px 0' }}>Historial de Abonos</Divider>
            <div style={{ maxHeight: 200, overflowY: 'auto' }}>
              {movement.payments.map((p: any, idx: number) => (
                <div key={p.id || idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px dashed #f0f0f0' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <strong>{getPaymentMethodLabel(p.payment_method, paymentOptions)}</strong>
                      {p.treasury_accounts?.name && (
                        <Tag color="cyan" style={{ fontSize: 10, lineHeight: '16px', padding: '0 4px', margin: 0 }}>
                          {p.treasury_accounts.name}
                        </Tag>
                      )}
                    </div>
                    <div style={{ color: '#8c8c8c', fontSize: 11 }}>
                      {p.payment_date ? formatDateTime(p.payment_date) : (p.created_at ? formatDateTime(p.created_at) : '')}
                      {p.reference ? ` - Ref: ${p.reference}` : ''}
                    </div>
                  </div>
                  <div style={{ fontWeight: 600, color: '#52c41a' }}>
                    {textNumberFormater(p.amount)}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Space>
    </Card>
  )
}

export default MovementDetailDebtCard
